import React, { useContext, useEffect, useRef, useState } from "react";
import "./PaymentFailed.css";
import CartSubtitle from "../ComponentsCheckoutPage/Components/CartSubtitle/CartSubtitle";
import CheckoutFooter from "../ComponentsCheckoutPage/Components/CheckoutFooter/CheckoutFooter";
import UniversalCheckoutHeader from "../../UniversalComponents/CheckoutHeader/CheckoutHeader";
import {
  ApiResponseGetPaymentLink,
  ApiResponseGetStoreItems,
  FinancialData,
  ItemDetailsData,
  RecommendedItem,
  ResponseCartItem,
} from "../../Utils/DefinitionsInterfaces";
import axios, { AxiosResponse } from "axios";
import { merchantLogoString } from "../../Utils/Constants";
import {
  fetchItemDetails,
  getOrderStatus,
  getPaymentLinkForOrder,
} from "../../Utils/CheckoutAPIs/CheckoutAPIs";
import { useNavigate } from "react-router-dom";

const PaymentFailed = () => {
  // const isApiCallNeededRef = useRef<boolean>(false);
  // const urlParams = new URLSearchParams(window.location.search);
  // const orderId = urlParams.get("order_id");
  // const itemIds = urlParams.get("item_ids");
  // const [cartResetNeeded, setCartResetNeeded] = useState(true);

  // const paymentCallbackFunction = async () => {
  //   if (orderId) {
  //     console.log("Order id =", orderId);
  //     const orderStatus = await verifyPayment(orderId);
  //     console.log("order status = ", orderStatus);
  //     if (orderStatus) {
  //       if (itemIds) {
  //         navigate(`/PaymentSuccessful/?item_ids=${itemIds}`);
  //       } else {
  //         navigate(`/PaymentSuccessful`);
  //       }
  //     } else {
  //       if (itemIds) {
  //         navigate(`/PaymentFailed/?item_ids=${itemIds}`);
  //       } else {
  //         navigate(`/PaymentFailed`);
  //       }
  //     }
  //   }
  // };

  // useEffect(() => {
  //   // fetchItemsList();
  //   paymentCallbackFunction();
  //   const handleBeforeUnload = (event: BeforeUnloadEvent): void => {
  //     // Prompt the user before they leave the page
  //     // event.preventDefault();
  //     event.returnValue = ""; // Required for Chrome
  //     sessionStorage.setItem("nfoCheckoutIsApiCallNeeded", "true");
  //   };

  //   window.addEventListener("beforeunload", handleBeforeUnload);

  //   const nfoCheckoutIsApiCallNeeded = sessionStorage.getItem(
  //     "nfoCheckoutIsApiCallNeeded"
  //   );
  //   if (
  //     nfoCheckoutIsApiCallNeeded &&
  //     nfoCheckoutIsApiCallNeeded !== "" &&
  //     nfoCheckoutIsApiCallNeeded === "false"
  //   ) {
  //     console.log("No need of api call");
  //   } else {
  //     console.log("Item Ids from url = ", itemIds);
  //     if (itemIds && itemIds.length > 0) {
  //       //&& !Number.isNaN(cartItemId)) {
  //       let itemsIdsAr: number[] = [];
  //       itemsIdsAr = itemIds.split("-").map(Number);
  //       populateItemDetails(itemsIdsAr);
  //       populateRecommendedItems(itemsIdsAr);
  //       setCartResetNeeded(false);
  //       sessionStorage.setItem("nfoCheckoutIsApiCallNeeded", "false");
  //     }
  //   }

  //   return () => {
  //     window.removeEventListener("beforeunload", handleBeforeUnload);
  //   };
  //   // return () => {
  //   //   sessionStorage.clear();
  //   // };
  // }, []);

  // useEffect(() => {
  //   const nfoCheckoutIsApiCallNeeded = sessionStorage.getItem(
  //     "nfoCheckoutIsApiCallNeeded"
  //   );
  //   if (
  //     nfoCheckoutIsApiCallNeeded &&
  //     nfoCheckoutIsApiCallNeeded !== "" &&
  //     nfoCheckoutIsApiCallNeeded === "false"
  //   ) {
  //     console.log("No need of api call");
  //   } else {
  //     console.log("Item Ids from url = ", itemIds);
  //     if (itemIds && itemIds.length > 0) {
  //       //&& !Number.isNaN(cartItemId)) {
  //       let itemsIdsAr: number[] = [];
  //       itemsIdsAr = itemIds.split("-").map(Number);
  //       populateItemDetails(itemsIdsAr);
  //       populateRecommendedItems(itemsIdsAr);
  //       setCartResetNeeded(false);
  //       sessionStorage.setItem("nfoCheckoutIsApiCallNeeded", "false");
  //     }
  //   }
  // }, [stateItemId]);

  // // const itemId = localStorage.getItem("itemId");
  // const itemId = sessionStorage.getItem("itemId");

  // const [cartItemId, setCartItemId] = useState(
  //   parseInt(itemId as unknown as string)
  // );

  // const navigate = useNavigate();

  // const populateItemDetails = async (itemIds: number[]): Promise<void> => {
  //   let foundItems: ItemDetailsData[] = [];
  //   for (let i = 0; i < itemIds.length; i++) {
  //     const foundItem = await fetchItemDetails(itemIds[i]);
  //     foundItems.push(foundItem[0]);
  //   }
  //   let numOrderItems = foundItems.length;

  //   let presArItems: ItemDetailsData[] = structuredClone(checkoutItems);
  //   console.log(foundItems);
  //   let isStateUpdateNeeded = true;
  //   if (presArItems.sort().join(",") === foundItems.sort().join(",")) {
  //     isStateUpdateNeeded = false;
  //   }

  //   if (isStateUpdateNeeded) setCheckoutItems(foundItems);
  // };

  // const populateDefaultItems = (defaultItem: FinancialData) => {
  //   let presDefaultItems: FinancialData[] = [];
  //   setDefaultItems([defaultItem]);
  // };

  // const populateRecommendedItems = async (
  //   cartItemIds: number[]
  // ): Promise<void> => {
  //   let defaultAndRecoItems = await fetchRecommendedItems();
  //   let newRecommendedItems = defaultAndRecoItems.recommendedItems;
  //   let defaultItem = defaultAndRecoItems.default;
  //   populateDefaultItems(defaultItem);
  //   let numOrderItems = newRecommendedItems.length;
  //   let presArItems: RecommendedItem[] = [];
  //   for (let i = 0; i < newRecommendedItems.length; i++) {
  //     if (cartItemIds.includes(newRecommendedItems[i].id)) {
  //       console.log(
  //         "Skipping this item from recommended as it is the base item"
  //       );
  //     } else {
  //       presArItems.push(newRecommendedItems[i]);
  //     }
  //   }
  //   console.log("PresArItems =", presArItems);
  //   console.log("recommendedItems = ", recommendedItems);
  //   let isRecommendedResetNeeded = false;
  //   if (recommendedItems.length !== presArItems.length)
  //     isRecommendedResetNeeded = true;
  //   for (
  //     let i = 0;
  //     !isRecommendedResetNeeded && i < newRecommendedItems.length;
  //     i++
  //   ) {
  //     if (presArItems[i].id !== recommendedItems[i].id)
  //       isRecommendedResetNeeded = true;
  //   }
  //   if (isRecommendedResetNeeded) setRecommendedItems(presArItems);
  // };

  // const handleRemoveItem = (itemId: number) => {
  //   let newItemsAr: ItemDetailsData[] = [];
  //   let newCheckoutItemsId: number[] = [];
  //   let isResetNeeded = false;
  //   for (let i = 0; i < checkoutItems.length; i++) {
  //     if (checkoutItems[i].id === itemId) {
  //       isResetNeeded = true;
  //     } else {
  //       newItemsAr.push(checkoutItems[i]);
  //       newCheckoutItemsId.push(checkoutItems[i].id);
  //     }
  //   }
  //   if (isResetNeeded) {
  //     setCheckoutItems(newItemsAr);
  //     populateRecommendedItems(newCheckoutItemsId);
  //     setCartItemId(NaN);
  //     isApiCallNeededRef.current = false;
  //     if (newItemsAr.length === 0) {
  //       window.location.href =
  //         "https://www.nfoportal.nationalfinanceolympiad.com/";
  //     }
  //   }
  // };

  // const handleAddItemFromRecommended = async (
  //   itemId: number
  // ): Promise<void> => {
  //   let foundItems = await fetchItemDetails(itemId);
  //   let numOrderItems = foundItems.length;

  //   let presArItems: ItemDetailsData[] = [];
  //   for (let i = 0; i < checkoutItems.length; i++) {
  //     presArItems.push(checkoutItems[i]);
  //   }
  //   for (let j = 0; j < foundItems.length; j++) {
  //     presArItems.push(foundItems[j]);
  //   }
  //   console.log(presArItems);
  //   setCheckoutItems(presArItems);

  //   //remove from recommended list now
  //   let newRecoItems: RecommendedItem[] = [];
  //   for (let k = 0; k < recommendedItems.length; k++) {
  //     if (recommendedItems[k].id === itemId) {
  //       console.log("Skipping this item from recommended");
  //     } else {
  //       newRecoItems.push(recommendedItems[k]);
  //     }
  //   }
  //   setRecommendedItems(newRecoItems);
  // };

  // const getSessionIdBD = async (
  //   orderIds: number[]
  // ): Promise<AxiosResponse<ApiResponseGetPaymentLink>> => {
  //   let orderNote = "";
  //   for (let i = 0; i < orderIds.length; i++) {
  //     orderNote += orderIds[i];
  //     if (i + 1 < orderIds.length) orderNote += ",";
  //   }
  //   // orderNote = "27,28";
  //   const RequestData = {
  //     orderNote: orderNote,
  //   };
  //   let responseGetLinks = await getPaymentLinkForOrder(RequestData);
  //   console.log("responseGetLinks = ", responseGetLinks);
  //   return responseGetLinks;
  // };

  // const handlePaymentClick = async (orderIds: number[]) => {
  //   let itemIdsString: string = "";
  //   for (let i = 0; i < checkoutItems.length; i++) {
  //     itemIdsString += checkoutItems[i].id;
  //     if (i + 1 !== checkoutItems.length) {
  //       itemIdsString += "-";
  //     }
  //   }
  //   try {
  //     const response = await getSessionIdBD(orderIds);
  //     //@ts-ignore
  //     console.log(response.data.data.links[1].parameters.bdorderid);
  //     //@ts-ignore
  //     if (response.data.status == "Success") {
  //       var flow_config = {
  //         //@ts-ignore
  //         merchantId: response.data.data.links[1].parameters.mercid,
  //         //@ts-ignore
  //         bdOrderId: response.data.data.links[1].parameters.bdorderid,
  //         //@ts-ignore
  //         authToken: response.data.data.links[1].headers.authorization,
  //         childWindow: true,
  //         //@ts-ignore
  //         returnUrl: `https://nfoself.checkout.nationalfinanceolympiad.com/CheckoutPage/?order_id=${response.data.data.orderID}&item_ids=${itemIdsString}`,
  //         retryCount: 3,
  //         prefs: {
  //           payment_categories: ["card", "nb", "upi"],
  //           // allowed_bins: ["540000", "400000"],
  //         },
  //         netBanking: {
  //           showPopularBanks: "Y",
  //           popularBanks: ["Kotak Bank", " AXIS Bank [Retail]"],
  //         },
  //       };

  //       var responseHandler = function (txn: {
  //         status: string;
  //         response: string;
  //       }) {
  //         console.log("callback received status:: ", txn.status);
  //         console.log("callback received response:: ", txn.response);
  //       };

  //       var theme_config = {
  //         sdkPrimaryColor: "#69068a",
  //         sdkAccentColor: "#cf5df5",
  //         sdkBackgroundColor: "#f2caff",
  //         sdkBannerColor: "#982cbb",
  //       };

  //       var config = {
  //         responseHandler: responseHandler,
  //         merchantLogo: merchantLogoString,
  //         flowConfig: flow_config,
  //         flowType: "payments",
  //         themeConfig: theme_config,
  //       };
  //       //@ts-ignore
  //       if (window.loadBillDeskSdk) {
  //         // Assuming you have a config object

  //         //@ts-ignore
  //         window.loadBillDeskSdk(config);
  //       }
  //     }
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };

  // const verifyPayment = async (orderId: string) => {
  //   try {
  //     const response = await getOrderStatus(orderId);
  //     if (response) {
  //       //@ts-ignore
  //       if (response.data.data.paymentStatus === "success") {
  //         console.log("Payment Successful");
  //         return true;
  //         //@ts-ignore
  //       } else if (response.data.data.paymentStatus === "retry") {
  //         console.log("Retry payment");
  //         return false;
  //         //@ts-ignore
  //       } else if (
  //         //@ts-ignore
  //         response.data.data.paymentStatus === "payment_processing_error"
  //       ) {
  //         console.log("payment_processing_error");
  //         return false;
  //       } else {
  //         return false;
  //       }
  //     }
  //   } catch (err) {
  //     return false;
  //   }
  // };

  return (
    <div className="checkout-summary-page">
      <div className="checkout">
        <UniversalCheckoutHeader />

        <CheckoutFooter />
      </div>
    </div>
  );
};

export default PaymentFailed;
